import { createBrowserRouter, Navigate } from "react-router";
import { RequireRole } from "./components/RequireRole.js";
import { AcceptInvitePage } from "./routes/AcceptInvitePage.js";
import { InvoicePrintPage } from "./routes/InvoicePrintPage.js";
import { LoginPage } from "./routes/LoginPage.js";
import { useSession, homePathFor } from "./lib/session.js";
import { AdminInvitesPage } from "./routes/admin/InvitesPage.js";
import { AdminOrgsPage } from "./routes/admin/OrgsPage.js";
import { AdminRoundsPage } from "./routes/admin/RoundsPage.js";
import { AdminSkusPage } from "./routes/admin/SkusPage.js";
import { RestaurantDealsPage } from "./routes/restaurant/DealsPage.js";
import { RestaurantInvoicesPage } from "./routes/restaurant/InvoicesPage.js";
import { RestaurantOrdersPage } from "./routes/restaurant/OrdersPage.js";
import { RestaurantRoundsPage } from "./routes/restaurant/RoundsPage.js";
import { SupplierDashboardPage } from "./routes/supplier/DashboardPage.js";
import { SupplierDealFinalizePage } from "./routes/supplier/DealFinalizePage.js";
import { SupplierDealsPage } from "./routes/supplier/DealsPage.js";
import { SupplierFinalizePage } from "./routes/supplier/FinalizePage.js";
import { SupplierInvoicesPage } from "./routes/supplier/InvoicesPage.js";
import { SupplierSkusPage } from "./routes/supplier/SkusPage.js";

// Routes get filled in across M1-M4. This covers auth (M1), group buying (M2), clearance
// deals (M3), and the supplier dashboard (M4).
function RootRedirect() {
  const { data: me, isPending } = useSession();
  if (isPending) return <p className="p-6 text-center text-stone-500">불러오는 중…</p>;
  return <Navigate to={me ? homePathFor(me.role) : "/login"} replace />;
}

export const router = createBrowserRouter([
  { path: "/", element: <RootRedirect /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/invite/:token", element: <AcceptInvitePage /> },
  {
    // Shared across roles: both a restaurant and a supplier print/download the same document.
    element: <RequireRole roles={["restaurant", "supplier", "admin"]} />,
    children: [{ path: "/invoices/:id/print", element: <InvoicePrintPage /> }],
  },
  {
    element: <RequireRole roles={["restaurant"]} />,
    children: [
      { path: "/rounds", element: <RestaurantRoundsPage /> },
      { path: "/deals", element: <RestaurantDealsPage /> },
      { path: "/orders", element: <RestaurantOrdersPage /> },
      { path: "/invoices", element: <RestaurantInvoicesPage /> },
    ],
  },
  {
    element: <RequireRole roles={["supplier"]} />,
    children: [
      { path: "/supplier", element: <SupplierDashboardPage /> },
      { path: "/supplier/deals", element: <SupplierDealsPage /> },
      { path: "/supplier/skus", element: <SupplierSkusPage /> },
      { path: "/supplier/invoices", element: <SupplierInvoicesPage /> },
      { path: "/supplier/rounds/:roundId/finalize", element: <SupplierFinalizePage /> },
      { path: "/supplier/deals/:dealId/finalize", element: <SupplierDealFinalizePage /> },
    ],
  },
  {
    element: <RequireRole roles={["admin"]} />,
    children: [
      { path: "/admin/orgs", element: <AdminOrgsPage /> },
      { path: "/admin/rounds", element: <AdminRoundsPage /> },
      { path: "/admin/skus", element: <AdminSkusPage /> },
      { path: "/admin/invites", element: <AdminInvitesPage /> },
    ],
  },
]);
